var map = {
	"./action_img.png": 305,
	"./background.png": 306,
	"./banner_shap.png": 307,
	"./cloud-computing.png": 308,
	"./cloud_01.png": 102,
	"./cloud_02.png": 103,
	"./cloud_03.png": 104,
	"./cloud_04.png": 105,
	"./cloud_05.png": 106,
	"./cloud_06.png": 107,
	"./crm_img1.jpg": 309,
	"./crm_img2.jpg": 310,
	"./crm_img3.jpg": 311,
	"./erp_dashboard.jpg": 108,
	"./erp_icon1.png": 312,
	"./erp_icon2.png": 313,
	"./erp_icon3.png": 314,
	"./erp_icon4.png": 315,
	"./erp_icon5.png": 316,
	"./erp_icon6.png": 317,
	"./growth.png": 318,
	"./img/01.png": 109,
	"./img/02.png": 110,
	"./img/03.png": 111,
	"./img/04.png": 112,
	"./img/05.png": 113,
	"./img/06.png": 114,
	"./img/07.png": 115,
	"./img/08.png": 116,
	"./img/09.png": 117,
	"./img/10.png": 118,
	"./img/11.png": 119,
	"./img/12.png": 120,
	"./img/13.png": 121,
	"./img/14.png": 122,
	"./img/15.png": 123,
	"./img/16.png": 124,
	"./img/17.png": 125,
	"./img/18.png": 126,
	"./img/19.png": 127,
	"./img/20.png": 128,
	"./quote.png": 319,
	"./rocket.png": 320,
	"./settings1.png": 321,
	"./shape.png": 322,
	"./testimonial_img.jpg": 323,
	"./testimonial_img2.jpg": 324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 589;